import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import moment from 'moment';
import { TimeZoneService } from './time-zone.service';
declare const Pusher: any;

@Injectable({
    providedIn: 'root'
})

export class GlobalService {
    token = localStorage.getItem('token');
    pusher: any;
    channel: any;
    refreshChannel: any;
    busEnrollChannel: any;
    bulkBusEnrollChannel: any;
    bulkStudentsUpdateChannel: any;
    tripAssignmentChannel: any;
    usrId = localStorage.getItem('userId');
    constructor(private translate: TranslateService, private http: HttpClient, private timeZoneService: TimeZoneService) {
        this.pusher = new Pusher(environment.PUSHER_API_KEY, {
            cluster: environment.PUSHER_API_CLUSTER,
            encrypted: true
        });
        this.channel = this.pusher.subscribe(`user_${localStorage.getItem('userId')}`);
        this.refreshChannel = this.pusher.subscribe(`web.refresh`);
        this.busEnrollChannel = this.pusher.subscribe(`bus_sudents_enrolment_school_${localStorage.getItem('schoolId')}`);
        this.bulkBusEnrollChannel = this.pusher.subscribe(`bus_import_${localStorage.getItem('schoolId')}`);
        this.tripAssignmentChannel = this.pusher.subscribe(`trip_assignment_${localStorage.getItem('schoolId')}`);
        this.bulkStudentsUpdateChannel = this.pusher.subscribe(`bulk_import_${localStorage.getItem('schoolId')}`);
        // Debug: confirms which Pusher channel this tab actually subscribed to, so a cross-school
        // realtime leak can be told apart from "this tab is on the wrong channel" vs "the backend
        // broadcast the event to the wrong channel".
        console.log('[Pusher] bulkStudentsUpdateChannel subscribed', {
            channel: this.bulkStudentsUpdateChannel.name,
            schoolId: localStorage.getItem('schoolId')
        });
    }

    private _toggleStartLoading = new BehaviorSubject<boolean>(true);
    toggleStartLoading = this._toggleStartLoading.asObservable();
    toggleStartLoadingFlag = true;
    private _toggleInitialLoading = new BehaviorSubject<boolean>(true);
    toggleInitialLoading = this._toggleInitialLoading.asObservable();
    toggleInitialLoadingFlag = true;

    private _languageChanged = new BehaviorSubject<String>(localStorage.getItem('lang'));
    languageChanged = this._languageChanged.asObservable();

    private _allGrades = new BehaviorSubject<Array<any>>([]);
    allGrades = this._allGrades.asObservable();

    startLoading() {
        this._toggleStartLoading.next(true);
    }

    stopLoading() {
        this._toggleStartLoading.next(false);
    }
    // stopLoading() {
    //     this.toggleStartLoadingFlag=false;
    //     if(!this.toggleInitialLoadingFlag){
    //         this._toggleStartLoading.next(false);
    //     }   
    // }

    getLoading() {
        return this._toggleStartLoading;
    }

    startInitialLoading() {
        this._toggleInitialLoading.next(true);
    }

    stopInitialLoading() {
        this._toggleInitialLoading.next(false);
    }

    // stopInitialLoading() {
    //     this.toggleInitialLoadingFlag=false;
    //     this._toggleInitialLoading.next(false);
    //     if(!this.toggleStartLoadingFlag){
    //         this.stopLoading();
    //     }
    // }

    getInitialLoading() {
        return this._toggleInitialLoading;
    }

    setLang(lang) {
        lang = lang ? lang : 'en';
        localStorage.setItem("lang", lang);
        this.translate.use(lang);
        this._languageChanged.next(lang);
        document.dir = lang == 'en' ? 'ltr' : 'rtl';
    }
    getLang() {
        return this._languageChanged;
    }

    setAllGrades(grades) {
        this._allGrades.next(grades);
    }
    getAllGrades() {
        return this._allGrades;
    }

    private _toggleExportAlert = new BehaviorSubject<string>('');
    toggleExportAlert = this._toggleExportAlert.asObservable();

    setExportAlert(type: string) {
        this._toggleExportAlert.next(type);
    }

    getExportAlert() {
        return this._toggleExportAlert;
    }

    private _togglePrintQrAlert = new BehaviorSubject<string>('');
    togglePrintQrAlert = this._togglePrintQrAlert.asObservable();

    setPrintQrAlert(type: string) {
        this._togglePrintQrAlert.next(type);
    }

    getPrintQrAlert() {
        return this._togglePrintQrAlert;
    }

    // for approve all requests in edit students 
    private _toggleApproveAllRequests = new BehaviorSubject<string>('');
    toggleApproveAllRequests = this._toggleApproveAllRequests.asObservable();

    setApproveAllRequests(type: string) {
        this._toggleApproveAllRequests.next(type);
    }

    getApproveAllRequests() {
        return this._toggleApproveAllRequests;
    }

    // for upload sheet 
    private _toggleUploadSheet = new BehaviorSubject<string>('');
    toggleUploadSheet = this._toggleUploadSheet.asObservable();

    setUploadSheet(type: string) {
        this._toggleUploadSheet.next(type);
    }

    getUploadSheet() {
        return this._toggleUploadSheet;
    }

    private _uploadErrorsUrl = new BehaviorSubject<string>('');
    uploadErrorsUrl = this._uploadErrorsUrl.asObservable();

    setUploadErrorsUrl(type: string) {
        this._uploadErrorsUrl.next(type);
    }

    getUploadErrorsUrl() {
        return this._uploadErrorsUrl;
    }

    private _enroll_notification_state = new BehaviorSubject<string>('not-uploading');
    enroll_notification_state = this._enroll_notification_state.asObservable();

    setBusEnrollNotificationState(state: string) {
        this._enroll_notification_state.next(state);
    }

    getBusEnrollNotificationState() {
        return this._enroll_notification_state.asObservable();
    }

    private _currentBusBulkEnrollBatchId = new BehaviorSubject<string>('');
    currentBusBulkEnrollBatchId = this._currentBusBulkEnrollBatchId.asObservable();

    setCurrentBusBulkEnrollBatchId(batchId: string) {
        this._currentBusBulkEnrollBatchId.next(batchId);
    }

    getCurrentBusBulkEnrollBatchId() {
        return this._currentBusBulkEnrollBatchId;
    }

    private _toggleBulkBusEnroll = new BehaviorSubject<any>({});
    toggleBulkBusEnroll = this._toggleBulkBusEnroll.asObservable();

    setBulkBusEnroll(bulkObj: any) {
        this._toggleBulkBusEnroll.next(bulkObj);
    }

    getBulkBusEnroll() {
        return this._toggleBulkBusEnroll.asObservable();
    }

    private _bulk_enroll_notification_state = new BehaviorSubject<string>('not-uploading');
    bulk_enroll_notification_state = this._bulk_enroll_notification_state.asObservable();

    setBulkEnrollNotificationState(state: string) {
        this._bulk_enroll_notification_state.next(state);
    }

    getBulkEnrollNotificationState() {
        return this._bulk_enroll_notification_state.asObservable();
    }

    private _notify_view_with_bulk_enroll_state = new BehaviorSubject<string>('not-uploading');
    notify_view_with_bulk_enroll_state = this._notify_view_with_bulk_enroll_state.asObservable();

    setNotifyViewWithBulkEnrollState(state: string) {
        this._notify_view_with_bulk_enroll_state.next(state);
    }

    getNotifyViewWithBulkEnrollState() {
        return this._notify_view_with_bulk_enroll_state.asObservable();
    }

    private _busBuldEnrollCounts = new BehaviorSubject<any>({});
    busBuldEnrollCounts = this._busBuldEnrollCounts.asObservable();

    setBulkBusEnrollCounts(bulkObj: any) {
        this._busBuldEnrollCounts.next(bulkObj);
    }

    getBulkBusEnrollCounts() {
        return this._busBuldEnrollCounts.asObservable();
    }

    private _auto_bus_enroll = new BehaviorSubject<boolean>(false);
    auto_bus_enroll = this._auto_bus_enroll.asObservable();

    setAutoBusEnroll(autoEnroll: boolean) {
        this._auto_bus_enroll.next(autoEnroll);
    }

    getAutoBusEnroll() {
        return this._auto_bus_enroll.asObservable();
    }
    

    sendMetaData(body) {
        return this.http.post(environment.url + `meta_data`, body)
    }

    // bulk students update
    private _toggleBulkStudentsUpdate = new BehaviorSubject<any>({});
    toggleBulkStudentsUpdate = this._toggleBulkStudentsUpdate.asObservable();

    setBulkStudentsUpdate(bulkObj: any) {
        this._toggleBulkStudentsUpdate.next(bulkObj);
    }

    getBulkStudentsUpdate() {
        return this._toggleBulkStudentsUpdate.asObservable();
    }

    private _bulk_students_update_notification_state = new BehaviorSubject<string>('not-uploading');
    bulk_students_update_notification_state = this._bulk_students_update_notification_state.asObservable();

    setBulkStudentsUpdateNotificationState(state: string) {
        this._bulk_students_update_notification_state.next(state);
    }

    getBulkStudentsUpdateNotificationState() {
        return this._bulk_students_update_notification_state.asObservable();
    }

    private _notify_view_with_bulk_student_update_state = new BehaviorSubject<string>('not-uploading');
    notify_view_with_bulk_student_update_state = this._notify_view_with_bulk_student_update_state.asObservable();

    setNotifyViewWithBulkStudentUpdateState(state: string) {
        this._notify_view_with_bulk_student_update_state.next(state);
    }

    getNotifyViewWithBulkStudentUpdateState() {
        return this._notify_view_with_bulk_student_update_state.asObservable();
    }

    // bulk students import

    private _toggleBulkStudentsImport = new BehaviorSubject<any>({});
    toggleBulkStudentsImport = this._toggleBulkStudentsImport.asObservable();

    setBulkStudentsImport(bulkObj: any) {
        this._toggleBulkStudentsImport.next(bulkObj);
    }

    getBulkStudentsImport() {
        return this._toggleBulkStudentsImport.asObservable();
    }

    private _bulk_students_import_notification_state = new BehaviorSubject<string>('not-uploading');
    bulk_students_import_notification_state = this._bulk_students_import_notification_state.asObservable();

    setBulkStudentsImportNotificationState(state: string) {
        this._bulk_students_import_notification_state.next(state);
    }

    getBulkStudentsImportNotificationState() {
        return this._bulk_students_import_notification_state.asObservable();
    }

    private _notify_view_with_bulk_student_import_state = new BehaviorSubject<string>('not-uploading');
    notify_view_with_bulk_student_import_state = this._notify_view_with_bulk_student_import_state.asObservable();

    setNotifyViewWithBulkStudentImportState(state: string) {
        this._notify_view_with_bulk_student_import_state.next(state);
    }

    getNotifyViewWithBulkStudentImportState() {
        return this._notify_view_with_bulk_student_import_state.asObservable();
    }

    // pioneer sync — single source of truth for both the cross-page sticky banner (any page, survives
    // navigation — resets only on a full reload, same limitation as the other bulk-import banners) and the
    // Data Management > Students page's own modal. 'syncing' while the request is in flight, 'ready' once
    // the bulk.import.status channel delivers a pioneer_sync_completed event with an unconsumed result,
    // 'idle' once that result has been shown/consumed.
    private _pioneerSync = new BehaviorSubject<{ state: 'idle' | 'syncing' | 'ready'; batchId?: string; result?: any }>({ state: 'idle', batchId: null, result: null });
    pioneerSync = this._pioneerSync.asObservable();

    setPioneerSync(data: { state: 'idle' | 'syncing' | 'ready'; batchId?: string; result?: any }) {
        this._pioneerSync.next({ ...this._pioneerSync.value, ...data });
    }

    getPioneerSync() {
        return this._pioneerSync.asObservable();
    }

    // holds { file_url, file_name } so the upload-new-students screen can pre-select the Pioneer-generated file
    private _pendingPioneerImportFile = new BehaviorSubject<any>(null);
    pendingPioneerImportFile = this._pendingPioneerImportFile.asObservable();

    setPendingPioneerImportFile(file: any) {
        this._pendingPioneerImportFile.next(file);
    }

    getPendingPioneerImportFile() {
        return this._pendingPioneerImportFile.asObservable();
    }


    /**
  * This method checks if the global dismissal period has started.
  * It finds the earliest dismissal `start_time` across all grades for today,
  * and compares it with the school's closing time.
  * 
  * @param grades Array of grade objects
  * @param schools Array of school objects
  * @returns true if dismissal started, false otherwise
  */
    checkIfDismissalStarted(grades: any[], schools: any[]) {
        // Get the current day of the week (e.g. "Monday")
        const today = moment().format('dddd');

        // Get current time as moment object
        const now = moment();

        // Loop through grades to find valid start times for today
        const validStartTimes = grades
            .map(grade => {
                // Find today's schedule from the dismissal_schedule array
                const todaySchedule = grade?.dismissal_schedule?.find(
                    (schedule: any) => schedule?.day_of_week === today
                );

                const startTime = todaySchedule?.start_time;

                if (startTime) {
                    // Find the school that matches this grade
                    const school = schools.find(s => s?.id === grade?.school_id);

                    // Get school's closing time
                    const closingTime = this.timeZoneService.convertToLocalTime(school?.school_closing_time, "HH:mm:ss", "HH:mm:ss");

                    if (closingTime) {
                        // Convert times to moment objects for comparison
                        const startMoment = moment(startTime, 'HH:mm:ss');
                        const closeMoment = moment(closingTime, 'HH:mm:ss');

                        return {
                            startMoment,
                            closeMoment
                        };
                    }
                }

                // If any data is missing, ignore this grade
                return null;
            })
            .filter(Boolean); // Remove null values

        // If no valid start times found, dismissal hasn't started
        if (validStartTimes.length === 0) {
            console.log('⚠️ No valid start times found for today.');
            return {isBetween: false};
        }

        // Find the earliest dismissal start time among all grades
        const earliest = validStartTimes.reduce((earliest, current) =>
            current.startMoment.isBefore(earliest.startMoment) ? current : earliest
        );


        console.log(`📘 Earliest dismissal start time: ${earliest.startMoment.format('HH:mm:ss')}`);
        console.log(`📘 now: ${now}`);
        console.log(`🏫 School closing time: ${earliest.closeMoment.format('HH:mm:ss')}`);


        // Check if current time is between earliest start and school's closing time
        const isBetween = now.isBetween(earliest.startMoment, earliest.closeMoment);
        console.log(`✅ Is dismissal started? ${isBetween ? 'YES ✅' : 'NO ❌'}`);

        return {isBetween: isBetween, start: earliest.startMoment, close: earliest.closeMoment};
    }
}